class SgcCounterBlock {
  run() {
    /* Regex for getting number in a string */
    const regExp = new RegExp("[0-9]+");

    /* Animation */
    const animateCountUp = (el) => {

      const digits = el.querySelectorAll(".digit-container");

      const text = el.getAttribute("original-text");
      const number = text.match(regExp);

      for (let i = 0; i < number[0].length; i++) {
        const d = digits[i].children[0];

        d.style.transform = `translateY(0px)`;
      }
    };

    /* Scroll based triggering of animation */
    const options = {
      rootMargin: "0px",
      threshold: 1.0,
    };
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        const el = entry.target;

        if (entry.isIntersecting) animateCountUp(el);
      });
    }, options);

    for (const el of document.getElementsByClassName("counter-text")) {
      const text = el.getAttribute("original-text");
      const number = text.match(regExp);
      const afterText = text.replace(regExp, "");

      if (number) {
        el.innerHTML = "";

        const odometer = document.createElement("div");
        odometer.classList.add("odometer");
        odometer.setAttribute("aria-hidden", "true");

        el.appendChild(odometer);

        for (let i = 0; i < number[0].length; i++) {
          const container = document.createElement("div");
          container.classList.add("digit-container");

          console.log(this.generateNumberString(8));

          const digit = document.createElement("p");
          digit.classList.add(`digit-${i}`);
          digit.innerHTML = this.generateNumberString(parseInt(number[0][i]))
          // digit.innerHTML = '0 1 2 3 4 5 6 7 8 9 0';
          digit.style.transitionDelay = `${(number[0].length - i)/8}s`;
          digit.style.transitionDuration = `${(10 - i)/2}s`;

          container.appendChild(digit);

          odometer.appendChild(container);

          digit.style.transform = `translateY(${(number[0][i]) * -(container.clientHeight)}px)`;
        }

        el.innerHTML += `<p class="after-text">${afterText}</p>`;

        observer.observe(el);
      } else {
        const bigText = document.createElement("p");
        bigText.innerHTML = text;
        
        el.appendChild(bigText);
      }
    }
  }

  generateNumberString(number) {
    let resString = `${number}`;

    for (let i = (number - 1); i >= 0; i--) {
      resString += ` ${i}`;
    }

    return resString;
  }
}

module.exports = SgcCounterBlock;
